import { createStronglyTypedTiptapNode } from "@blocknote/core";

/**
 * 다단 레이아웃의 단일 컬럼 노드 `column`.
 *
 * 스키마(core/src/pm-nodes/README.md, MIT):
 *   group:   "bnBlock childContainer"
 *   content: "blockContainer+"  (컬럼은 1개 이상의 블록을 담는다)
 *
 * MVP은 모든 컬럼을 균등 폭(flex:1)으로 렌더한다. 향후 너비 리사이즈를 위해 선택적
 * `width` attr 자리만 둔다(현재 CSS 미사용).
 */
export const Column = createStronglyTypedTiptapNode({
  name: "column",
  group: "bnBlock childContainer",
  content: "blockContainer+",

  addAttributes() {
    return {
      width: {
        default: 1,
        parseHTML: (element) => {
          const w = parseFloat(element.getAttribute("data-column-width") || "");
          return Number.isFinite(w) && w > 0 ? w : 1;
        },
        renderHTML: (attributes) => {
          if (!attributes.width || attributes.width === 1) {
            return {};
          }
          return { "data-column-width": String(attributes.width) };
        },
      },
    };
  },

  parseHTML() {
    return [{ tag: 'div[data-node-type="column"]' }];
  },

  renderHTML({ HTMLAttributes }) {
    const dom = document.createElement("div");
    dom.className = "bn-column";
    dom.setAttribute("data-node-type", "column");
    for (const [attribute, value] of Object.entries(HTMLAttributes)) {
      if (attribute !== "class") {
        dom.setAttribute(attribute, value as string);
      }
    }
    return { dom, contentDOM: dom };
  },
});
